import { render } from "./SetQx.vue?vue&type=template&id=6fcdbd1e&scoped=true"
import script from "./SetQx.vue?vue&type=script&lang=js"
export * from "./SetQx.vue?vue&type=script&lang=js"

import "./SetQx.vue?vue&type=style&index=0&id=6fcdbd1e&lang=less"
import "./SetQx.vue?vue&type=style&index=1&id=6fcdbd1e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcdbd1e"]])

export default __exports__